var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _circle4, _circle5, _circle6, _path21, _path22, _path23, _path24, _path25, _ellipse, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _ellipse2, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaitingRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 728,
    height: 415,
    viewBox: "0 0 728 415",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 179.5,
    r: 47.5,
    fill: "#D9DFE6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 387,
    cy: 29,
    r: 17,
    fill: "#D9DFE6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 522.5,
    cy: 127.5,
    r: 25.5,
    fill: "#D9DFE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M469.902 376a15.442 15.442 0 0 0 4.026-9H484.5c6.904 0 12.5-5.596 12.5-12.5s-5.596-12.5-12.5-12.5h-78c-5.317 0-9.859 3.32-11.666 8H351.5c-3.157 0-6.093.944-8.543 2.564A7.975 7.975 0 0 0 340 352H207a8 8 0 0 0 0 16h15.755A8 8 0 0 0 229 381h90a8 8 0 0 0 6.245-13h10.956c.885 5.462 4.625 9.966 9.638 11.934A11.455 11.455 0 0 0 343 387.5c0 6.351 5.149 11.5 11.5 11.5h127c6.351 0 11.5-5.149 11.5-11.5s-5.149-11.5-11.5-11.5h-11.598z",
    fill: "#F2F5F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m327.465 137.949 11.439-28.975a4.242 4.242 0 0 1 3.483-2.658l17.306-1.896a4.241 4.241 0 0 1 3.864 1.683l9.294 12.485c.358.482.61 1.034.74 1.621l4.652 21.135c.478 2.17-.8 4.34-2.929 4.976l-17.513 5.231a4.24 4.24 0 0 1-2.174.067l-17.992-4.18a4.29 4.29 0 0 1-1.023-.382l-7.185-3.8a4.242 4.242 0 0 1-1.962-5.307z",
    fill: "#0A76F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M238.907 222.071c0-11.713 9.495-21.208 21.208-21.208h166.268c11.713 0 21.208 9.495 21.208 21.208v27.994c0 11.713-9.495 21.208-21.208 21.208H260.115c-11.713 0-21.208-9.495-21.208-21.208v-27.994z",
    fill: "#ECF0F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M262.782 215.855a21.207 21.207 0 0 1 20.619-15.741l129.504.779c6.64.04 11.63 6.072 10.425 12.601a10.666 10.666 0 0 0 2.697 9.219l11.343 12.136a21.207 21.207 0 0 1 5.553 11.878l1.461 11.806a4.808 4.808 0 0 1-4.609 5.395l-182.518 6.143a6.694 6.694 0 0 1-6.693-8.416l12.218-45.8z",
    fill: "#D9DFE6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m302.184 241.872 37.711-2.055 70.929-22.07a4.243 4.243 0 0 0 2.981-4.074l-.199-35.789c-.014-2.589-2.307-4.551-4.854-4.087-10.008 1.82-33.3 6.627-47.88 14.197-44.006 22.849-58.688 53.878-58.688 53.878z",
    fill: "#EAF3FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M271.991 363.525a8.483 8.483 0 0 1-8.483-8.483v-59.593a8.483 8.483 0 0 1 8.483-8.483h6.15a8.483 8.483 0 0 1 8.484 8.483v59.593a8.483 8.483 0 0 1-8.484 8.483h-6.15zM413.447 358.859a8.483 8.483 0 0 1-8.484-8.483v-54.928a8.483 8.483 0 0 1 8.484-8.483h6.15a8.483 8.483 0 0 1 8.483 8.483v54.928a8.483 8.483 0 0 1-8.483 8.483h-6.15z",
    fill: "#D9DFE6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M304.227 192.275c0-21.61 17.518-39.129 39.128-39.129h5.09c21.61 0 39.128 17.519 39.128 39.129s-17.518 39.128-39.128 39.128h-5.09c-21.61 0-39.128-17.518-39.128-39.128z",
    fill: "#EAF3FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M399.661 166.932h19.299l-1.973 26.244a2.12 2.12 0 0 1-2.115 1.962H403.75a2.12 2.12 0 0 1-2.115-1.962l-1.974-26.244z",
    fill: "#C6DEFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M230 284.633c0-7.496 6.077-13.572 13.573-13.572h213.561c7.496 0 13.573 6.076 13.573 13.572 0 7.497-6.077 13.573-13.573 13.573H243.573c-7.496 0-13.573-6.076-13.573-13.573z",
    fill: "#ECF0F4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M290.23 375.826a8.483 8.483 0 0 1-8.483-8.483v-74.227a8.483 8.483 0 0 1 8.483-8.483h10.18a8.483 8.483 0 0 1 8.483 8.483v74.227a8.483 8.483 0 0 1-8.483 8.483h-10.18zM431.049 375.826a8.483 8.483 0 0 1-8.483-8.483v-73.379a8.483 8.483 0 0 1 8.483-8.483h10.18a8.483 8.483 0 0 1 8.483 8.483v73.379a8.483 8.483 0 0 1-8.483 8.483h-10.18z",
    fill: "#ECF0F4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M230.424 281.452c0-5.739 4.653-10.391 10.392-10.391h219.075c5.74 0 10.392 4.652 10.392 10.391H230.424z",
    fill: "#D9DFE6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M304.227 251.338c0-11.01 8.925-19.936 19.935-19.936h43.476c11.01 0 19.935 8.926 19.935 19.936 0 11.009-8.925 19.935-19.935 19.935h-43.476c-11.01 0-19.935-8.926-19.935-19.935z",
    fill: "#2D8CFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M360.215 231.402h57.473c11.01 0 19.935 8.926 19.935 19.936",
    fill: "#0A76F9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M352.05 280.709h12.619l-5.514 17.708h-12.301l5.196-17.708zM402.949 280.709h12.618l2.227 17.708h-10.71l-4.135-17.708z",
    fill: "#D9DFE6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m414.295 302.761-14.496-42.451c-3.571-10.457 2.129-21.81 12.648-25.192",
    fill: "#0A76F9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M323.102 231.402h66.38c11.01 0 19.935 8.926 19.935 19.936",
    fill: "#2D8CFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m349.611 313.744 20.013-63.661c3.244-10.318 14.237-16.052 24.554-12.809",
    fill: "#2D8CFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M305.711 216.132a4.242 4.242 0 0 1 4.242-4.241h72.318v33.296h-76.56v-29.055z",
    fill: "#2D8CFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M330.324 181.266c.394-7.068 6.084-12.85 13.162-12.85h30.302a8.483 8.483 0 0 1 8.483 8.483v35.032l-65.744.385s11.286-12.218 12.831-21.372c.477-2.829.778-6.308.966-9.678z",
    fill: "#2D8CFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.887 229.917c0-.937.759-1.696 1.696-1.696h41.992a1.696 1.696 0 1 1 0 3.393h-41.992c-.937 0-1.696-.76-1.696-1.697zM357.67 209.346c-.937 0-1.696-.76-1.696-1.697v-37.538a1.696 1.696 0 1 1 3.393 0v37.538c0 .937-.76 1.697-1.697 1.697z",
    fill: "#0A76F9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 363.396,
    cy: 175.413,
    r: 1.697,
    fill: "#0A76F9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 363.396,
    cy: 188.988,
    r: 1.697,
    fill: "#0A76F9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 363.396,
    cy: 202.56,
    r: 1.697,
    fill: "#0A76F9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m344.097 153.783 2.227-9.332 3.075.742 11.558 1.591 2.121 7.741-7.21 3.817-11.771-4.559zM360.34 318.038l3.093-8.841 3.939.846 15.642 1.63-4.31 11.249-8.039 3.092-10.325-7.976zM425.535 311.144l-2.439-8.271h6.15l12.301-1.379 1.484 9.65-7.21 3.817-10.286-3.817z",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M346.704 161.556a7.411 7.411 0 0 0 9.684-4.013l-13.697-5.671a7.412 7.412 0 0 0 4.013 9.684z",
    fill: "#0A76F9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M362.682 159.642a4.809 4.809 0 0 0 2.011-6.497l-8.507 4.486a4.808 4.808 0 0 0 6.496 2.011zM399.874 166.294c0-.469.379-.849.848-.849h17.602a.849.849 0 1 1 0 1.697h-17.602a.848.848 0 0 1-.848-.848z",
    fill: "#0A76F9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m325.646 157.175-2.967 37.432-23.245 74.117a4.242 4.242 0 0 1-4.047 2.973h-34.334c-2.607 0-4.586-2.322-4.115-4.886 1.965-10.699 7.255-36.414 15.053-51.103 23.251-43.794 53.655-58.533 53.655-58.533z",
    fill: "#EAF3FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M326.312 155.614a.848.848 0 0 1 .572-1.054l6.1-1.81a.848.848 0 0 1 1.054.572l6.213 20.942-7.726 2.292-6.213-20.942zM370.247 159.282a.848.848 0 0 1 .985-.684l6.261 1.131a.848.848 0 0 1 .685.985l-2.27 12.572-7.931-1.432 2.27-12.572z",
    fill: "#2D8CFF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 355.019,
    cy: 127.484,
    rx: 19.193,
    ry: 23.116,
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M357.458 129.076a1.696 1.696 0 1 1-3.391 0 1.696 1.696 0 0 1 3.391 0zM365.941 129.076a1.696 1.696 0 1 1-3.391 0 1.696 1.696 0 0 1 3.391 0z",
    fill: "#C4DDFF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.749 135.878a.85.85 0 0 1 1.165.288c1.151 1.909 4.732 5.519 9.773 4.898a.85.85 0 0 1 .208 1.684c-5.987.737-10.112-3.514-11.434-5.705a.849.849 0 0 1 .288-1.165zM361.263 131.953a.848.848 0 0 1 1.164.291l.249.414a3.265 3.265 0 0 1-1.339 4.599.849.849 0 0 1-.759-1.518 1.566 1.566 0 0 0 .643-2.208l-.249-.414a.85.85 0 0 1 .291-1.164z",
    fill: "#C3DDFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M353.999 124.215c-.836 0-1.168-1.081-.476-1.55l1.545-1.049a.848.848 0 0 1 1.214.284l.595 1.048a.848.848 0 0 1-.738 1.267h-2.14zM366.33 122.699c.695.465.369 1.548-.466 1.553l-1.867.012a.85.85 0 0 1-.852-.91l.089-1.202a.847.847 0 0 1 1.317-.643l1.779 1.19z",
    fill: "#C4DDFF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M400.298 175.414h18.026l-.53 7.423h-16.966l-.53-7.423z",
    fill: "#2D8CFF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M417.723 172.461a2.97 2.97 0 0 0-.034 5.941l3.013.017a2.97 2.97 0 1 0 .034-5.941l-3.013-.017zm-1.06 5.938a2.97 2.97 0 0 0-.034 5.941l.861.005a2.972 2.972 0 0 0 .123 5.932 2.97 2.97 0 0 0 .076 5.939l3.013.018a2.97 2.97 0 0 0 .111-5.94 2.97 2.97 0 0 0-.077-5.939l-.86-.005a2.972 2.972 0 0 0-.2-5.934l-3.013-.017z",
    fill: "#EAF3FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M397.811 184.393a2.97 2.97 0 0 1 3.735-1.922l2.869.919a2.97 2.97 0 1 1-1.813 5.658l-2.869-.919a2.97 2.97 0 0 1-1.922-3.736z",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M348.901 304.664a.847.847 0 0 1 .929-.758l43.044 4.349a.849.849 0 0 1 .759.93l-.895 8.862a.848.848 0 0 1-.93.758l-43.044-4.349a.849.849 0 0 1-.759-.93l.896-8.862z",
    fill: "#0A76F9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M410.994 298.244a.848.848 0 0 1 .751-.936l43.004-4.735a.85.85 0 0 1 .936.751l.974 8.853a.847.847 0 0 1-.75.936l-43.004 4.735a.848.848 0 0 1-.936-.751l-.975-8.853z",
    fill: "#0165DE"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m358.511 105.991.22.497c.954 2.757 1.68 3.99.954 5.727-4.41 10.555-13.674 13.815-16.648 13.997h-.894c-1.187 0-2.322-.5-3.125-1.374a4.249 4.249 0 0 0-5.309-.771l-2.336 1.402 6.676-16.832a4.244 4.244 0 0 1 3.12-2.597l12.639-2.498a4.24 4.24 0 0 1 4.703 2.449z",
    fill: "#2D8CFF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m360.544 116.838-2.378-10.358a4.412 4.412 0 0 0-.188-.605l-.293-.744a2.12 2.12 0 0 1 1.642-2.872l1.312-.207a4.24 4.24 0 0 1 3.647 1.176l8.739 8.657a4.235 4.235 0 0 1 1.199 2.321l1.995 12.062a.413.413 0 0 1-.543.463c-1.328-.464-4.365-1.597-6.235-2.852-2.965-1.988-5.851-6.193-7.226-8.376-.232-.369-.833-.202-.833.234v1.007c0 .505-.725.587-.838.094zM338.866 144.042l-1.343-9.521-1.548-8.724c-.43-2.429-3.777-2.769-4.687-.475l-4.751 14.401a4.24 4.24 0 0 0 1.976 5.041l5.161 2.853a3.523 3.523 0 0 0 5.192-3.575z",
    fill: "#2D8CFF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 336.787,
    cy: 129.727,
    rx: 4.454,
    ry: 8.059,
    transform: "rotate(-17.64 336.787 129.727)",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.301 122.758a.849.849 0 0 1 1.199-.055c.994.906 1.926 2.068 2.701 3.42.806 1.408 1.349 2.859 1.618 4.223a.85.85 0 0 1-1.665.328c-.23-1.168-.703-2.447-1.425-3.707-.693-1.211-1.518-2.232-2.372-3.01a.85.85 0 0 1-.056-1.199zM358.689 150.126a.85.85 0 0 1-.71.968c-1.329.204-2.819.2-4.358-.046-1.602-.257-3.072-.746-4.302-1.393a.848.848 0 0 1 .79-1.502c1.054.555 2.346.99 3.78 1.219 1.378.221 2.69.22 3.832.045a.848.848 0 0 1 .968.709z",
    fill: "#E4EFFB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m368.334 143.058 2.281-22.62a2.033 2.033 0 0 1 3.981-.349l5.515 19.512a4.246 4.246 0 0 1-.338 3.147l-.921 1.729a4.237 4.237 0 0 1-2.196 1.955l-2.554 1.001c-2.954 1.157-6.086-1.219-5.768-4.375z",
    fill: "#2D8CFF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M371.88 124.939c-.509.085-2.404-.884-3.288-1.378l1.167 5.301-2.333 10.18c-.177 2.086-.318 6.108.53 5.514.848-.594 2.192-4.418 2.757-6.256l1.167-6.468v-6.893zM287.509 276.27a3.764 3.764 0 0 1-3.728-3.799l.028-3.075a3.764 3.764 0 0 1 7.527.071l-.029 3.074a3.764 3.764 0 0 1-3.798 3.729zM264.953 274.717a3.764 3.764 0 0 1-3.728-3.799l.021-2.262a3.765 3.765 0 0 1 3.799-3.729 3.765 3.765 0 0 1 3.728 3.799l-.021 2.263a3.764 3.764 0 0 1-3.799 3.728z",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M272.462 276.27a3.764 3.764 0 0 1-3.728-3.799l.036-3.817a3.763 3.763 0 1 1 7.526.071l-.035 3.816a3.765 3.765 0 0 1-3.799 3.729z",
    fill: "#fff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M279.969 278.029a3.762 3.762 0 0 1-3.728-3.798l.052-5.575a3.763 3.763 0 0 1 3.798-3.728 3.762 3.762 0 0 1 3.728 3.798l-.052 5.575a3.762 3.762 0 0 1-3.798 3.728z",
    fill: "#fff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M412.552 132.605a4.601 4.601 0 0 0-8.774.935l-.225 1.226a7.376 7.376 0 0 0 .95 5.154l3.908 6.44a25.43 25.43 0 0 1 3.666 14.305 1.697 1.697 0 0 1-3.39-.148c.19-4.356-.915-8.67-3.177-12.397l-3.908-6.439a10.775 10.775 0 0 1-1.387-7.526l.225-1.226a7.991 7.991 0 0 1 3.714-5.393c4.187-2.542 9.655-.755 11.532 3.769l.814 1.96a6.196 6.196 0 0 1-.484 5.681l-.246.39c-2.011 3.184-6.468 3.655-9.1.962l-.146-.15a5.335 5.335 0 0 1-1.517-3.843l.002-.06a5.257 5.257 0 0 1 4.24-5.043 1.696 1.696 0 0 1 .655 3.33 1.863 1.863 0 0 0-1.503 1.787l-.001.061c-.012.52.187 1.024.551 1.397l.146.149a2.437 2.437 0 0 0 3.804-.402l.246-.39a2.799 2.799 0 0 0 .218-2.568l-.813-1.961z",
    fill: "#EAF3FF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M403.479 160.993a1.272 1.272 0 0 1 2.545 0v4.878a1.272 1.272 0 0 1-2.545 0v-4.878z",
    fill: "#0A76F9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M399.608 166.333a.423.423 0 0 1 .387-.251h18.844c.167 0 .319.098.387.251l1.534 3.432a.849.849 0 0 1-.775 1.195h-21.136a.849.849 0 0 1-.775-1.195l1.534-3.432z",
    fill: "#2D8CFF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M356.143 340.35a1.696 1.696 0 0 1 1.948-1.401l27.087 4.423c11.56 1.887 19.401 12.788 17.514 24.348l-.645 3.946a1.696 1.696 0 0 1-1.948 1.401l-48.018-7.84 4.062-24.877z",
    fill: "#0A76F9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m347.16 337.164 22.654 3.699-4.335 26.551-20.561-3.357a2.12 2.12 0 0 1-1.751-2.435l3.993-24.458zM349.308 324.01l35.807 5.846-2.147 13.154-35.808-5.846 2.148-13.154z",
    fill: "#0A76F9"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M346.276 319.98a4.162 4.162 0 0 1 4.779-3.438l34.733 5.671a4.164 4.164 0 0 1-1.341 8.217l-34.734-5.671a4.162 4.162 0 0 1-3.437-4.779zM343.349 363.929a.49.49 0 0 1 .564-.406l57.169 9.334a.49.49 0 0 1 .406.564 2.46 2.46 0 0 1-2.824 2.032l-53.284-8.7a2.46 2.46 0 0 1-2.031-2.824z",
    fill: "#0165DE"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.082 341.171a2.121 2.121 0 0 1-1.8-2.399l.885-6.193a2.121 2.121 0 0 1 4.199.6l-.885 6.192a2.12 2.12 0 0 1-2.399 1.8z",
    fill: "#0165DE"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M429.895 331.84a1.696 1.696 0 0 1 1.514-1.861l24.877-2.557c11.651-1.198 22.067 7.277 23.265 18.928l.276 2.682a1.698 1.698 0 0 1-1.515 1.861l-45.973 4.725-2.444-23.778z",
    fill: "#0A76F9"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m420.843 331.064 21.728-2.233 2.618 25.466-19.619 2.017a2.121 2.121 0 0 1-2.326-1.893l-2.401-23.357zM419.546 318.447l34.345-3.53 1.296 12.616-34.344 3.531-1.297-12.617z",
    fill: "#0A76F9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M415.76 315.501a3.96 3.96 0 0 1 3.536-4.345l33.313-3.425a3.962 3.962 0 1 1 .81 7.881l-33.313 3.425a3.963 3.963 0 0 1-4.346-3.536zM423.995 356.597a.468.468 0 0 1 .418-.514l54.832-5.636a.468.468 0 0 1 .513.418 2.34 2.34 0 0 1-2.089 2.568l-51.106 5.253a2.342 2.342 0 0 1-2.568-2.089z",
    fill: "#0165DE"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M447.385 327.817a2.12 2.12 0 0 1-2.364-1.846l-.702-5.704a2.121 2.121 0 0 1 4.21-.518l.702 5.705a2.12 2.12 0 0 1-1.846 2.363z",
    fill: "#0165DE"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M413.463 175.416a2.971 2.971 0 0 1 2.988-2.954l3.013.018a2.97 2.97 0 0 1-.034 5.941l-3.013-.018a2.97 2.97 0 0 1-2.954-2.987zM412.403 181.353a2.97 2.97 0 0 1 2.988-2.953l3.012.017a2.971 2.971 0 0 1-.034 5.941l-3.012-.017a2.971 2.971 0 0 1-2.954-2.988z",
    fill: "#fff"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M413.463 187.291a2.971 2.971 0 0 1 2.988-2.954l3.013.018a2.97 2.97 0 0 1-.034 5.941l-3.013-.018a2.97 2.97 0 0 1-2.954-2.987z",
    fill: "#fff"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M413.463 193.23a2.97 2.97 0 0 1 2.988-2.953l3.013.017a2.97 2.97 0 0 1-.034 5.941l-3.013-.017a2.971 2.971 0 0 1-2.954-2.988z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 352,
    width: 32,
    height: 16,
    rx: 8,
    fill: "#F2F5F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 343,
    width: 54,
    height: 22,
    rx: 11,
    fill: "#F2F5F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingRoom);
export default __webpack_public_path__ + "static/media/waiting_room.b53001653e98cd5d295876f823b658b5.svg";
export { ForwardRef as ReactComponent };